module.exports = __webpack_public_path__ + "img/logo.f33a96b3.png";